<script context="module">
    import { env } from '../Environment.svelte';

    const buildOfferTree = (isResidential = true, isTripleplay = true) => {
        const commonOfferFields = `
        coverage
        coverageType
        offers {
            tripleplay_modular { ${env.paqData} }
            residencial_modular { ${env.paqData} }
            tv_modular { ${env.paqData} }
            izzimovil_modular { ${env.paqData} }
            offnet_izzi { ${env.paqData} }
            offnet_sky { ${env.paqData} }
            offnet_izzi_movil { ${env.paqData} }
        }
    `;

        const businessOfferFields = `
        offers {
            izzinegocios { ${env.paqData} }
            izzinegocios_3P { ${env.paqData} }
        }
    `;

        if (!isResidential) {
            return `{ coverage coverageType ${businessOfferFields} }`;
        } else if (isResidential && isTripleplay) {
            return `{ ${commonOfferFields} }`;
        } else {
            return `{ ${commonOfferFields} }`;
        }
    };

    const sendGraphqlRequest = async (query, myHeaders) => {
        const requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: JSON.stringify({ query, variables: {} }),
            redirect: 'follow',
        };

        const response = await fetch(
            env[env.stage].api.url + 'izziweb/ms/offer/graphql',
            requestOptions
        );
        if (!response.ok) {
            throw new Error('Error al consumir el servicio');
        }
        return response.json();
    };

    export async function fetchOffer(postalCode, addressId, offnet) {
        const myHeaders = new Headers({
            'x-api-key': env[env.stage].api.key,
            'Content-Type': 'application/json',
        });

        try {
            const queryTriple = `
            {
                izzioffer(id: "${addressId}", cp: "${postalCode}", offnet: ${offnet}) 
                ${buildOfferTree(true, true)}
            }
        `;

            const queryOffnet = `
            {
                izzioffer(id: "${addressId}", cp: "${postalCode}", offnet: ${true}) 
                ${buildOfferTree(true, true)}
            }
        `;

            const queryResidential = `
            {
                izzioffer(id: "${addressId}", cp: "${postalCode}", offnet: ${offnet}, isTripleplay: false) 
                ${buildOfferTree(true, false)}
            }
        `;

            const queryBusiness = `
            {
                izzioffer(id: "${addressId}", cp: "${postalCode}", offnet: ${offnet}, isResidential: false) 
                ${buildOfferTree(false)}
            }
        `;

            const [
                resultTriple,
                resultOffnet,
                resultResidential,
                resultBusiness,
            ] = await Promise.all([
                sendGraphqlRequest(queryTriple, myHeaders),
                sendGraphqlRequest(queryOffnet, myHeaders),
                sendGraphqlRequest(queryResidential, myHeaders),
                sendGraphqlRequest(queryBusiness, myHeaders),
            ]);

            const izziofferTriple = resultTriple.data.izzioffer;
            const izziofferOffnet = resultOffnet.data.izzioffer;
            const izziofferResidential = resultResidential.data.izzioffer;
            const izziofferBusiness = resultBusiness.data.izzioffer;

            const responseOffer = {
                coverage: izziofferTriple.coverage,
                coverageType: izziofferTriple.coverageType,
                offers: {
                    tripleplay_modular:
                        izziofferTriple.offers.tripleplay_modular,
                    residencial_modular:
                        izziofferResidential.offers.residencial_modular,
                    tv_modular: izziofferResidential.offers.tv_modular,
                    izzimovil_modular:
                        izziofferResidential.offers.izzimovil_modular,
                    izzinegocios: izziofferBusiness.offers.izzinegocios,
                    izzinegocios_3P: izziofferBusiness.offers.izzinegocios_3P,
                    offnet_izzi: izziofferOffnet?.offers?.offnet_izzi ?? [],
                    offnet_sky: izziofferOffnet?.offers?.offnet_sky ?? [],
                    offnet_izzi_movil:
                        izziofferOffnet?.offers?.offnet_izzi_movil ?? [],
                },
            };

            return responseOffer;
        } catch (error) {
            console.error('Error fetching offers:', error);
            return { error: 'Error fetching offers' };
        }
    }

    export async function fetchInitOffer() {
        const myHeaders = new Headers({
            'x-api-key': env[env.stage].api.key,
            'Content-Type': 'application/json',
        });

        try {
            const queryTriple = `
            {
                izzioffer(id: "", cp: "") 
                ${buildOfferTree(true, true)}
            }
        `;

            const queryOffnet = `
            {
                izzioffer(id: "", cp: "", offnet: ${true}) 
                ${buildOfferTree(true, true)}
            }   
        `;

            const queryResidential = `
            {
                izzioffer(id: "", cp: "", isTripleplay: false) 
                ${buildOfferTree(true, false)}
            }
        `;

            const queryBusiness = `
            {
                izzioffer(id: "", cp: "", isResidential: false) 
                ${buildOfferTree(false)}
            }
        `;

            const [
                resultTriple,
                resultOffnet,
                resultResidential,
                resultBusiness,
            ] = await Promise.all([
                sendGraphqlRequest(queryTriple, myHeaders),
                sendGraphqlRequest(queryOffnet, myHeaders),
                sendGraphqlRequest(queryResidential, myHeaders),
                sendGraphqlRequest(queryBusiness, myHeaders),
            ]);

            const izziofferTriple = resultTriple.data.izzioffer;
            const izziofferOffnet = resultOffnet.data.izzioffer;
            const izziofferResidential = resultResidential.data.izzioffer;
            const izziofferBusiness = resultBusiness.data.izzioffer;

            const responseOffer = {
                coverage:
                    izziofferResidential.coverage || izziofferTriple.coverage,
                coverageType:
                    izziofferResidential.coverageType ||
                    izziofferTriple.coverageType,
                offers: {
                    tripleplay_modular:
                        izziofferTriple.offers.tripleplay_modular,
                    residencial_modular:
                        izziofferResidential.offers.residencial_modular,
                    tv_modular: izziofferResidential.offers.tv_modular,
                    izzimovil_modular:
                        izziofferResidential.offers.izzimovil_modular,
                    izzinegocios: izziofferBusiness.offers.izzinegocios,
                    izzinegocios_3P: izziofferBusiness.offers.izzinegocios_3P,
                    offnet_izzi: izziofferOffnet.offers.offnet_izzi,
                    offnet_sky: izziofferOffnet.offers.offnet_sky,
                    offnet_izzi_movil: izziofferOffnet.offers.offnet_izzi_movil,
                },
            };

            return responseOffer;
        } catch (error) {
            console.error('Error fetching offers:', error);
            return { error: 'Error fetching offers' };
        }
    }
</script>
